import React, { memo, useCallback } from 'react';
import { NavLink, useParams } from 'react-router-dom';

import { classer } from 'utils';

import classes from './SubMenu.module.scss';

const SubMenu = ({
  options,
  setChildRef,
  expanded,
  isActiveParent,
  hideDrawer,
  onClickSelectSection,
  name
}) => {
  const { bu, lang } = useParams();

  const onClickLink = useCallback(() => {
    onClickSelectSection({ name, isSubMenu: true });
    hideDrawer();
  }, [hideDrawer, name, onClickSelectSection]);

  return (
    <ul className={classes.SubMenu}>
      {options.map(({ title, name: sectionName }, i) => (
        <li
          key={`${sectionName}${i}`}
          ref={ref => setChildRef(sectionName, ref)}
          className={classer([
            classes.SubPageInner,
            expanded ? classes.Expanded : classes.Collapsed,
            isActiveParent && classes.ActiveSubPageInner
          ])}
          aria-hidden={!expanded}
        >
          <NavLink
            className={classes.SubPage}
            activeClassName={classes.ActiveNavLink}
            to={`/${bu}/${sectionName}/${lang}`}
            exact
            tabIndex={expanded ? 0 : -1}
            onClick={onClickLink}
          >
            <span className={classes.Name}>{title}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

export default memo(SubMenu);
